import camelCase from 'lodash/camelCase';
import { isFedRamp } from '@atlassian/atl-context';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import { getServiceDeskSettingsResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { servicedeskPlaybooksTemplateCreateRoute } from '@atlassian/jira-router-routes-project-settings-playbooks-routes/src/servicedeskPlaybooksTemplateCreateRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { SIDEBAR_ID, MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { fg } from '@atlassian/jira-feature-gating';

import playbookTemplateCreateViewEntryPoint from '@atlassian/jira-spa-apps-project-settings-playbooks-template-create/entrypoint.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { PlaybookEditSkeleton } from '@atlassian/jira-playbooks-edit-screen/src/ui/skeleton/PlaybookEditSkeleton.tsx';
import { notFoundPageEntrypoint } from '@atlassian/jira-router-routes-not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';

const playbookTemplateCreateEntryPoint = createPageEntryPoint({
	main: playbookTemplateCreateViewEntryPoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
});

export const servicedeskPlaybooksTemplateCreateRouteEntry = createEntry(
	servicedeskPlaybooksTemplateCreateRoute,
	() => ({
		group: 'project-settings-servicedesk',
		layout: serviceProjectLayout,

		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncSidebarServicedesk,
			sidebarId: SIDEBAR_ID.PROJECT_SETTINGS,
		},

		entryPoint() {
			if (isFedRamp() && !fg('phantom-3577-playbook-templates')) {
				return notFoundPageEntrypoint;
			}
			return playbookTemplateCreateEntryPoint;
		},

		resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],

		meta: {
			reporting: {
				id: 'project-settings.playbooks.admin-template-create-view',
				packageName: camelCase('project-settings-playbooks-template-create'),
				teamName: 'ITOps Phantom',
			},
		},

		component: ErrorPagesNotFound,
		ufoName: 'playbook-template-create',
		skeleton: PlaybookEditSkeleton,

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-project-settings-playbooks-entries/src/servicedeskPlaybooksTemplateCreateRouteEntry.tsx',
				whichExportToUse: 'servicedeskPlaybooksTemplateCreateRouteEntry',
			},

			enabled: true,
		},
	}),
);
